<script setup lang="ts">
const props = defineProps<{
  path: Parameters<typeof useArticle>[0]
}>()

const { data: article, error, suspense } = useArticle(props.path)

await suspense()

if (article.value) {
  provide(keys.currentArticle, article.value)
  useDocumentSeo(article.value)
}
</script>

<template>
  <UiCommonsError v-if="error" :error="error" />
  <UiArticlesContent v-if="article">
    <slot />
  </UiArticlesContent>
</template>
